<template>
  <div style="height: 100%">
    <!-- HEADER -->
    <v-row class="rowView">
      <v-col
        class="colView h5"
        style="color: var(--color-text)"
      >
        Fouling
      </v-col>

      <v-spacer />

      <v-btn
        text
        small
        class="ma-auto pa-1"
        color="var(--color-text) !important"
        @click="dialog = true"
      >
        Fouling History
      </v-btn>
    </v-row>

    <!-- MAIN CHART -->
    <v-row
      class="rowView"
      style="height: calc(100% - 25px)"
    >
      <v-col
        class="colView"
        :cols="12"
      >
        <v-card style="background-color: var(--color-bg) !important">
          <v-card-title
            class="bodyBold"
            style="color: var(--color-text)"
          >
            Increased Power due to Fouling
          </v-card-title>

          <v-card-actions>
            <highcharts
              ref="mainChart"
              :key="mainChartKey"
              :options="clonedFoulingData"
              style="width: 100%; height: 100%"
            />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- HISTORY DIALOG -->
    <v-dialog
      v-model="dialog"
      max-width="1400px"
    >
      <v-card style="background-color: var(--color-bg) !important">
        <v-card-title
          class="bodyBold"
          style="color: var(--color-text) !important"
        >
          Fouling History
        </v-card-title>

        <v-card-actions>
          <v-col
            class="colView"
            :cols="12"
          >
            <highcharts
              ref="historyChart"
              :key="historyChartKey"
              :options="clonedAllFouling"
              style="width: 100%; height: 500px"
            />

            <!-- LEGEND -->
            <v-row class="rowView mt-4">
              <v-col
                class="colView"
                :cols="12"
              >
                <ul
                  style="
                    display: inline-block;
                    text-align: center;
                    list-style: none;
                    width: 100%;
                    color: var(--color-text);
                  "
                >
                  <li
                    v-for="item in eventDict"
                    :key="item.abbr"
                    style="display: inline-flex; margin: 0px 10px"
                  >
                    <b>{{ item.abbr }}:</b>
                    <span style="margin-left: 5px;">
                      {{ item.full }}
                    </span>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FoulingChartPanel",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: { type: Boolean, default: false },
    foulingData: { type: Object, required: true },
    allFouling: { type: Object, required: true },
    eventDict: { type: Array, required: true },
  },

  data() {
    return {
      mainChartKey: 0,
      historyChartKey: 0,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },

    //  Always clone to force reactivity
    clonedFoulingData() {
      if (!this.foulingData) return {};
      const clone = JSON.parse(JSON.stringify(this.foulingData));
      clone.tooltip = {
        formatter: function () {
          const date = new Date(this.x).toLocaleDateString("en-GB", {
            year: "numeric", month: "short", day: "2-digit"
          });
          return `<b>Date:</b> ${date}<br/><b>Value:</b> ${this.y.toFixed(2)}`;
        }
      };
      return clone;
    },

    clonedAllFouling() {
      if (!this.allFouling) return {};
      const clone = JSON.parse(JSON.stringify(this.allFouling));
      clone.tooltip = {
        formatter: function () {
          const date = new Date(this.x).toLocaleDateString("en-GB", {
            year: "numeric", month: "short", day: "2-digit"
          });
          return `<b>Date:</b> ${date}<br/><b>Value:</b> ${this.y.toFixed(2)}`;
        }
      };
      return clone;
    },
  },

  watch: {
    // Main chart updates
    foulingData: {
      deep: true,
      handler() {
        this.mainChartKey++;
      },
    },

    // History chart updates
    allFouling: {
      deep: true,
      handler() {
        this.historyChartKey++;
      },
    },

    // Reflow when dialog opens
    dialog(val) {
      if (val) {
        const self = this;
        this.$nextTick(function () {
          setTimeout(function () {
            if (
              self.$refs &&
              self.$refs.historyChart &&
              self.$refs.historyChart.chart
            ) {
              self.$refs.historyChart.chart.reflow();
            }
          }, 0);
        });
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  border-color: var(--color-border) !important;
}
.v-btn:hover {
  background-color: var(--color-primary-light) !important;
}
.v-btn--disabled {
  background-color: var(--color-neutral) !important;
  color: var(--color-text-muted) !important;
}
.v-btn--plain {
  background-color: transparent !important;
  color: var(--color-text) !important;
}
.v-btn--plain:hover {
  background-color: var(--color-overlay) !important;
}
</style>
